import axios from 'axios';

export const fetcher = (url, token) =>
  axios.get(url, { headers: { Authorization: 'Bearer ' + token, 'x-access-token': token } }).then((res) => res.data);
